export const INTA_CERRILLOS_CENTER = [-24.895, -65.4788];
export const INTA_CERRILLOS_LABEL = 'INTA Cerrillos';
export const INTA_CORDOBA_CENTER = [-31.4680219, -64.1476382];
export const INTA_CORDOBA_LABEL = 'INTA CIAP Córdoba';
export const CASE_LOCATION_DEFAULT_ZOOM = 14;
export const DASHBOARD_DEFAULT_ZOOM = 12;
